module.exports = __webpack_public_path__ + "static/media/gopay.12c74a43.svg";